
import IPresentazioneProps from "pages/Prenotazione/Form/Presentazione/IPresentazioneProps";
import { CustomButton } from "core/interfaces/components/index";

import { LogoHome } from "assets/customAssets";

import "./Presentazione.css";
import { CustomButtonType } from "components/CustomButton/CustomButtonType";
import { Enhanced } from "utils/ReactUtils";
import { useEffect, useRef } from "react";

const Presentazione: React.FC<IPresentazioneProps> = ({ OnClick, t }) => {
	const startRef: any = useRef();
	useEffect(() => {
		if (startRef.current) startRef.current.focus();
	}, []);

	return (
		// eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
		<div id="presentation" role="main" aria-label="Step 1" tabIndex={0}>
			<div className="title presentation-item">
				<span>{t("presentation.title")}</span>
				<div id="logo-image-home" aria-hidden={true}>
					<img key={Date.now()} alt="logo" src={LogoHome} />
				</div>
			</div>

			<div className="presentation-text presentation-item">
				<span>{t("presentation.text.0")}</span>
				<span>{t("presentation.text.1")}</span>
				<span>{t("presentation.text.2")}</span>
			</div>
			<div className="init-button presentation-item">
				<CustomButton text={t("presentation.start")} OnClick={OnClick} buttonType={CustomButtonType.positive} />
			</div>
		</div>
	);
};

export default Enhanced( Presentazione,{componentNamespace:"Presentazione"});
